import { Typography } from '@mui/material';
import { forwardRef } from 'react';

import {
  ContactOrBusinessPartner,
  isContact,
} from './contact-or-business-partner';

export interface ContactTextProps extends React.HTMLAttributes<HTMLDivElement> {
  contact: ContactOrBusinessPartner;
}

export const ContactText = forwardRef<HTMLDivElement, ContactTextProps>(
  function ContactText(props, ref) {
    const { contact, ...otherProps } = props;

    if (!contact) {
      return null;
    }

    const renderContent = () => {
      if (isContact(contact)) {
        return (
          <>
            {contact.displayName}

            <Typography component="span" variant="body2" color="text.tertiary">
              {' | '} {contact.businessPartner?.data.name}
            </Typography>
          </>
        );
      } else {
        return contact.name;
      }
    };

    return (
      <Typography
        ref={ref}
        component="div"
        variant="body2"
        noWrap
        {...otherProps}
      >
        {renderContent()}
      </Typography>
    );
  }
);

export function contactAsString(contact: ContactOrBusinessPartner): string {
  if (!contact) return '';

  if (isContact(contact)) {
    return [contact?.displayName, contact?.businessPartner?.data.name]
      .filter(Boolean)
      .join(' | ');
  } else {
    return contact.name;
  }
}
